/**
 * Sports Realm — header behaviour.
 *
 * Only what the mockup demonstrates and Horizon does not already provide:
 *   1. solid-on-scroll state (>40px)
 *   2. mobile nav open/close + accordion
 *
 * Search and cart are NOT handled here — they use Horizon's declarative
 * `on:click="#search-modal/showDialog"` and `on:click="#cart-drawer/toggle"`
 * bindings, resolved by the delegated listener in assets/component.js.
 */
(function () {
  'use strict';

  function init() {
    var header = document.querySelector('[data-sr-header]');
    var mnav = document.querySelector('[data-sr-mnav]');
    var openBtn = document.querySelector('[data-sr-menu-open]');
    var closeBtn = document.querySelector('[data-sr-menu-close]');

    /* ---- 1. Solid on scroll ----
       The document does not always scroll. At >=990px Horizon's base.css applies
       `html:has(.page-wrapper), html:has(.page-wrapper) body { height:100dvh;
       overflow:hidden }` and makes .page-wrapper the scroll container, so
       window.scrollY stays 0 forever and window scroll events never fire — which
       is why the solid state never engaged on desktop. Below 990px that rule is
       not in the media query and the document scrolls normally.

       Read whichever container actually moved, and listen in the CAPTURE phase:
       scroll events do not bubble, so a listener on window/document would never
       see .page-wrapper scrolling. */
    if (header) {
      var scrollBox = document.querySelector('.page-wrapper');

      var scrolledY = function () {
        var docY = window.scrollY || document.documentElement.scrollTop || 0;
        return scrollBox ? Math.max(docY, scrollBox.scrollTop) : docY;
      };

      var onScroll = function () {
        header.classList.toggle('sr-is-solid', scrolledY() > 40);
      };

      onScroll();
      document.addEventListener('scroll', onScroll, { capture: true, passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }

    if (!mnav || !openBtn) return;

    /* ---- 2. Mobile nav ---- */
    var lastFocused = null;

    function openMenu() {
      lastFocused = document.activeElement;
      mnav.hidden = false;
      // Force a reflow so the browser registers the pre-transition state before
      // the class flips; this is synchronous, unlike requestAnimationFrame, which
      // does not fire in a backgrounded/throttled tab and would leave the drawer
      // un-hidden but parked off-screen with body scroll locked.
      void mnav.offsetWidth;
      mnav.classList.add('sr-is-open');
      document.body.classList.add('sr-no-scroll');
      openBtn.setAttribute('aria-expanded', 'true');
      if (closeBtn) closeBtn.focus();
    }

    function closeMenu() {
      mnav.classList.remove('sr-is-open');
      document.body.classList.remove('sr-no-scroll');
      openBtn.setAttribute('aria-expanded', 'false');
      var done = function () {
        mnav.hidden = true;
        mnav.removeEventListener('transitionend', done);
      };
      mnav.addEventListener('transitionend', done);
      // fallback when transitions are disabled (reduced motion)
      setTimeout(done, 600);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    openBtn.addEventListener('click', openMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);

    // Accordion rows
    mnav.querySelectorAll('[data-sr-acc]').forEach(function (row) {
      var btn = row.querySelector('.sr-mnav__link');
      var sub = row.querySelector('.sr-mnav__sub');
      if (!btn || !sub) return;
      btn.addEventListener('click', function () {
        var open = row.classList.toggle('sr-is-active');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        sub.style.maxHeight = open ? sub.scrollHeight + 'px' : 0;
      });
    });

    // Any real link closes the menu
    mnav.querySelectorAll('a[href]').forEach(function (a) {
      a.addEventListener('click', closeMenu);
    });

    // Escape closes; keep focus inside while open
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (mnav.classList.contains('sr-is-open')) closeMenu();
    });

    mnav.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !mnav.classList.contains('sr-is-open')) return;
      var items = mnav.querySelectorAll('a[href], button:not([disabled])');
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-render
  document.addEventListener('shopify:section:load', init);
})();
